window.addEventListener('DOMContentLoaded', () => {
  fetch('/cart.js')
    .then((obj) => obj.json())
    .then((cart) => {
      let protectionVariantId = null;
      let giftBagInCart = false; 
      cart.items.forEach((item) => {
        if (item.handle.includes('zyn-shipping-protection')) {
          protectionVariantId = item.variant_id;
        }
        if (item.handle.includes("gift-bag")) {
          giftBagInCart = true; 
        }
      });
      if (protectionVariantId) {
        const removeRequest = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: String(protectionVariantId),
            quantity: 0
          })
        }
        fetch('/cart/change.js', removeRequest)
          .then((response) => response.json())
          .then((data) => {
            console.log('Removed protection:', data);
          })
          .then(() => {
            console.log('Attribute cleared');
            window.location.reload();
          });
      } else {
        if (!giftBagInCart) {
          $('#giftAttribute').prop('checked', false);
          sessionStorage.setItem("checkboxState", "unchecked");
        }
      }
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            shipping_protection_choice: null
          }
        })
      });
    })
    .catch(error => console.error('Error:', error));
});